import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultNegativeFeedbackPopoverBodyOptions = [{
  value: 'incorrectAction',
  label: /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "aiComponentsUiLibrary.components.inlineFeedback.messageFeedback.options.incorrectAction"
  })
}, {
  value: 'notRelevant',
  label: /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "aiComponentsUiLibrary.components.inlineFeedback.messageFeedback.options.notRelevant"
  })
}, {
  value: 'incomplete',
  label: /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "aiComponentsUiLibrary.components.inlineFeedback.messageFeedback.options.incomplete"
  })
}, {
  value: 'inaccurate',
  label: /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "aiComponentsUiLibrary.components.inlineFeedback.messageFeedback.options.inaccurate"
  })
}, {
  value: 'other',
  label: /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "aiComponentsUiLibrary.components.inlineFeedback.messageFeedback.options.other"
  })
}];
const FeedbackButtons = ({
  selectedOptions,
  onOptionSelect,
  negativeFeedbackPopoverBodyOptions = defaultNegativeFeedbackPopoverBodyOptions
}) => {
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    alignItems: "stretch",
    children: negativeFeedbackPopoverBodyOptions.map(option => {
      if (isNaN(Number(option))) {
        return /*#__PURE__*/_jsx(Checkbox, {
          "data-test-id": "feedback-button",
          checked: selectedOptions.includes(option.value),
          onChange: () => onOptionSelect(option.value),
          children: /*#__PURE__*/_jsx(Text, {
            typography: "detail-200",
            children: option.label
          })
        }, option.value);
      }
      return null;
    })
  });
};
export default FeedbackButtons;